/**
 * BulkSelectionContext
 *
 * Contexto simple para comunicar cuando hay bulk selection activa
 * Usado para ocultar elementos flotantes que podrían interferir (ej: AIMiniChat)
 */

import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface BulkSelectionContextValue {
  hasBulkSelection: boolean;
  setBulkSelection: (active: boolean) => void;
}

const BulkSelectionContext = createContext<BulkSelectionContextValue | null>(null);

export function BulkSelectionProvider({ children }: { children: ReactNode }) {
  const [hasBulkSelection, setHasBulkSelection] = useState(false);

  const setBulkSelection = useCallback((active: boolean) => {
    setHasBulkSelection(active);
  }, []);

  return (
    <BulkSelectionContext.Provider value={{ hasBulkSelection, setBulkSelection }}>
      {children}
    </BulkSelectionContext.Provider>
  );
}

export function useBulkSelection() {
  const context = useContext(BulkSelectionContext);
  // Si no hay provider, retornar valores por defecto (para no romper)
  if (!context) {
    return { hasBulkSelection: false, setBulkSelection: () => {} };
  }
  return context;
}
